export enum NotificationTypes {
    Success,
    Info,
    Error,
    Warning,
}
